import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type AncillaryTypes = (typeof ALLOWED_ANCILLARY_TYPES)[number]

export const ALLOWED_ANCILLARY_TYPES = [
  'stay',
  'transfer',
  'car_rental',
  'guide',
  'skycop',
  'flight-hotel',
] as const

export const AncillaryTypeValidation = z.object({
  value: z.enum(ALLOWED_ANCILLARY_TYPES, {
    required_error: 'value is required',
  }),
})

export class AncillaryType extends Model {
  static create({ value }: z.infer<typeof AncillaryTypeValidation>) {
    AncillaryTypeValidation.parse({ value })
    return new AncillaryType(value)
  }

  static isTransfer(type: AncillaryTypes) {
    return type === 'transfer'
  }

  static isCarRental(type: AncillaryTypes) {
    return type === 'car_rental'
  }

  static isFlightHotel(type: AncillaryTypes) {
    return type === 'flight-hotel'
  }

  constructor(private readonly _value: AncillaryTypes) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
